<atx-picture-in-picture
  [activate]="pipActive"
  (exitPip)="exitPictureInPicture()"
>
  @if (id || url) { @if (disablePlaceholder) {
  <youtube-player
    data-e2e="youtube-player"
    class="youtube-player"
    #player
    [videoId]="videoId"
    [playerVars]="{
      rel: 0,
      showinfo: 0,
      playsinline: 1,
      mute: muted,
      autoplay: playerAutoplay,
      controls: controlsEnabled
    }"
    (ready)="playerReady()"
    (error)="videoError.emit()"
    (stateChange)="onVideoStateChangeEvent($event)"
    disablePlaceholder
  >
  </youtube-player>
  } @else {
  <youtube-player
    data-e2e="youtube-player"
    class="youtube-player"
    #player
    [videoId]="videoId"
    [playerVars]="{
      rel: 0,
      showinfo: 0,
      playsinline: 1,
      mute: muted,
      autoplay: playerAutoplay,
      controls: controlsEnabled
    }"
    (ready)="playerReady()"
    (error)="videoError.emit()"
    (stateChange)="onVideoStateChangeEvent($event)"
  >
  </youtube-player>
  } }
</atx-picture-in-picture>
